import { Routes, Route, Navigate } from 'react-router-dom'
import { Providers } from './components/providers'

// Public pages (mirror davidogbueli.org)
import LandingPage from './pages/landing'
import AboutPage from './pages/about'
import MinistryAboutPage from './pages/ministry/about'
import CoreValuesPage from './pages/ministry/core-values'
import StatementOfFaithPage from './pages/ministry/statement-of-faith'
import LeadershipPage from './pages/leadership'
import EventsPage from './pages/events'
import BiographyPage from './pages/about/biography'
import TestimonyPage from './pages/about/testimony'
import VisionPage from './pages/about/vision'
import MediaPage from './pages/media'
import ResourcesPage from './pages/resources'
import ContactPage from './pages/contact'
import GivePage from './pages/give'
import PrivacyPage from './pages/privacy'
import TermsPage from './pages/terms'
import HelpPage from './pages/help'

// Broadcast (NEW feature)
import BroadcastPage from './pages/broadcast/index';
import PublicBroadcastPage from './pages/broadcast/public';
import PrivateBroadcastPage from './pages/broadcast/private';

// Mentorship
import MentorshipPage from './pages/features/mentorship';
import GMTVPage from './pages/features/gmtv';

// Auth pages
import SignInPage from './pages/auth/signin'
import SignUpPage from './pages/auth/signup'
import RegisterPage from './pages/auth/register'
import RequestAccessPage from './pages/request-access'
import MagicLinkRequestPage from './pages/auth/magic-link-request'
import MagicLinkCallbackPage from './pages/auth/magic-link-callback'
import AuthCallbackPage from './pages/auth/callback'
import ForgotPasswordPage from './pages/auth/forgot-password'
import UpdatePasswordPage from './pages/auth/update-password'
import VerifyEmailPage from './pages/auth/verify'
import JoinPage from './pages/join/[code]'

// Internal pages (require auth - not in main public nav)
import DashboardPage from './pages/dashboard'
import StreamsPage from './pages/streams'
import ProfilePage from './pages/profile'
import SettingsPage from './pages/settings'
import StreamDetailPage from './pages/streams/[streamId]'
import CommentsPage from './pages/comments'
import NotificationsPage from './pages/notifications'
import DemoStreamsPage from './pages/demo-streams'
import AccountDeletionRequestPage from './pages/account-deletion-request'

// Admin pages
import AdminDashboardPage from './pages/admin'
import AdminStreamsPage from './pages/admin/streams'
import AdminNewStreamPage from './pages/admin/new-stream'
import AdminStreamDetailPage from './pages/admin/streams/[id]'
import AdminRecordingsPage from './pages/admin/recordings'
import AdminUsersPage from './pages/admin/users'
import AdminUserDetailPage from './pages/admin/users/[id]'
import AdminAuditLogsPage from './pages/admin/audit-logs'
import AdminLiveInputsPage from './pages/admin/live-inputs'
import AdminRequestsPage from './pages/admin/requests'
import AdminAccessRequestsPage from './pages/admin/access-requests'
import AdminWebhooksPage from './pages/admin/webhooks'
import AdminBroadcastsPage from './pages/admin/broadcasts'
import AdminModerationPage from './pages/admin/moderation'
import AdminHeroManagerPage from './pages/admin/hero-manager'
import ModerationReportsPage from './pages/moderator/reports'

// Not found
import NotFoundPage from './pages/404'

// Layouts
import { LandingLayout } from './components/layouts/landing-layout'
import { PublicLayout } from './components/layouts/public-layout'
import { AuthenticatedLayout } from './components/layouts/authenticated-layout'

// Route guards
import { ProtectedRoute } from './components/auth/protected-route'
import { PublicOnlyRoute } from './components/auth/public-only-route'

function App() {
  return (
    <Providers>
      <Routes>
        {/* Landing page - Public only (redirects authenticated users to dashboard) */}
        <Route path="/" element={<PublicOnlyRoute />}>
          <Route element={<LandingLayout />}>
            <Route index element={<LandingPage />} />
          </Route>
        </Route>

        {/* ═══════════════════════════════════════════════════════════════════
           PUBLIC PAGES — mirrors davidogbueli.org
           These routes are visible to all visitors and appear in the
           public navigation header. Do NOT add internal/admin routes
           here — those go in the PROTECTED section below.
           ═══════════════════════════════════════════════════════════════════ */}
        <Route path="/" element={<PublicLayout hasHeroSection={false} />}>
          {/* About Pastor */}
          <Route path="about" element={<AboutPage />} />
          <Route path="about/biography" element={<BiographyPage />} />
          <Route path="about/testimony" element={<TestimonyPage />} />
          <Route path="about/vision" element={<VisionPage />} />
          <Route path="about/pastor" element={<Navigate to="/about" replace />} />

          {/* Ministry */}
          <Route path="ministry" element={<MinistryAboutPage />} />
          <Route path="ministry/about" element={<MinistryAboutPage />} />
          <Route path="ministry/core-values" element={<CoreValuesPage />} />
          <Route path="ministry/statement-of-faith" element={<StatementOfFaithPage />} />

          {/* Leadership (accessible but not in primary nav) */}
          <Route path="leadership" element={<LeadershipPage />} />

          <Route path="events" element={<EventsPage />} />

          {/* Media */}
          <Route path="media" element={<MediaPage />} />

           {/* Resources */}
           <Route path="resources" element={<ResourcesPage />} />

           {/* Mentorship */}
           <Route path="mentorship" element={<MentorshipPage />} />

           {/* GMTV */}
           <Route path="gmtv" element={<GMTVPage />} />
           <Route path="media/gmtv" element={<GMTVPage />} />

           {/* Contact */}
           <Route path="contact" element={<ContactPage />} />

          {/* Give */}
          <Route path="give" element={<GivePage />} />

          {/* Legal (not in nav, but publicly accessible) */}
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="account-deletion-request" element={<AccountDeletionRequestPage />} />

           {/* Broadcast — public hub and public stream */}
           <Route path="broadcast" element={<BroadcastPage />} />
           <Route path="broadcast/public" element={<PublicBroadcastPage />} />

           {/* Route aliases to match reference site */}
           <Route path="ministries" element={<Navigate to="/ministry" replace />} />
           <Route path="login" element={<Navigate to="/signin" replace />} />
           <Route path="watch" element={<Navigate to="/broadcast" replace />} />
           <Route path="vod" element={<Navigate to="/broadcast" replace />} />
        </Route>

        {/* ═══════════════════════════════════════════════════════════════════
           AUTH PAGES — sign in / sign up / recovery
           Publicly accessible but uses a layout without footer.
           ═══════════════════════════════════════════════════════════════════ */}
        <Route path="/" element={<PublicLayout showFooter={false} hasHeroSection={false} />}>
          <Route path="signin" element={<SignInPage />} />
          <Route path="auth/signin" element={<SignInPage />} />
          <Route path="auth/signup" element={<SignUpPage />} />
          <Route path="auth/register" element={<RegisterPage />} />
          <Route path="auth/magic-link-request" element={<MagicLinkRequestPage />} />
          <Route path="auth/magic-link" element={<MagicLinkCallbackPage />} />
          <Route path="auth/callback" element={<AuthCallbackPage />} />
          <Route path="auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="auth/update-password" element={<UpdatePasswordPage />} />
          <Route path="auth/verify" element={<VerifyEmailPage />} />
          <Route path="request-access" element={<RequestAccessPage />} />
        </Route>

        {/* Invite join page - public */}
        <Route path="/join/:code" element={<JoinPage />} />

        {/* ═══════════════════════════════════════════════════════════════════
           PROTECTED / INTERNAL ROUTES — requires authentication
           These routes are NOT in the public navigation.
           They support internal platform operations: dashboard,
           streams, admin, moderator, etc.
           ═══════════════════════════════════════════════════════════════════ */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AuthenticatedLayout />}>
            {/* Private Broadcast — requires login */}
            <Route path="/broadcast/private" element={<PrivateBroadcastPage />} />

            {/* User dashboard and settings */}
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />

            {/* Stream routes */}
            <Route path="/streams">
              <Route index element={<StreamsPage />} />
              <Route path=":streamId" element={<StreamDetailPage />} />
            </Route>

            {/* Community */}
            <Route path="/comments" element={<CommentsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />

            {/* Demo (for testing) */}
            <Route path="/demo" element={<DemoStreamsPage />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/streams">
              <Route index element={<AdminStreamsPage />} />
              <Route path="new" element={<AdminNewStreamPage />} />
              <Route path=":id" element={<AdminStreamDetailPage />} />
            </Route>
            <Route path="/admin/recordings" element={<AdminRecordingsPage />} />
            <Route path="/admin/users">
              <Route index element={<AdminUsersPage />} />
              <Route path=":id" element={<AdminUserDetailPage />} />
            </Route>
            <Route path="/admin/audit-logs" element={<AdminAuditLogsPage />} />
            <Route path="/admin/live-inputs" element={<AdminLiveInputsPage />} />
            <Route path="/admin/requests" element={<AdminRequestsPage />} />
            <Route path="/admin/access-requests" element={<AdminAccessRequestsPage />} />
            <Route path="/admin/webhooks" element={<AdminWebhooksPage />} />
            <Route path="/admin/broadcasts" element={<AdminBroadcastsPage />} />
            <Route path="/admin/moderation" element={<AdminModerationPage />} />
            <Route path="/admin/hero-manager" element={<AdminHeroManagerPage />} />

            {/* Moderator routes */}
            <Route path="/moderator" element={<DashboardPage />} />
            <Route path="/moderator/reports" element={<ModerationReportsPage />} />

            {/* Pastor routes */}
            <Route path="/pastor" element={<DashboardPage />} />
          </Route>
        </Route>

        {/* ═══════════════════════════════════════════════════════════════════
            LOCALE FALLBACK — redirects /en/* to root as a safety net
            This handles any stale URL normalization that may have been missed.
            ═══════════════════════════════════════════════════════════════════ */}
        <Route path="/en" element={<Navigate to="/" replace />} />
        <Route path="/en/*" element={<Navigate to="/" replace />} />

        {/* Catch all route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Providers>
  )
}

export default App
